import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = {
  key: 1,
  class: "actions"
}

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import { AuthMethods } from '@/models/auth-methods';
import { useAuthStore } from '@/stores/authStore';
import { getCurrentTime } from '@/utils/utils';
import { computed } from 'vue';

interface Props {
  dateTime?: string;
  title: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BotMessageHeader',
  props: {
    dateTime: {},
    title: {}
  },
  setup(__props: any) {



const authStore = useAuthStore();
const logoName = computed(() => {
  return authStore.authMethod === AuthMethods.Spain ? 'logo-es' : 'logo-fr';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(AppIcon, {
        name: logoName.value,
        size: "headline-s"
      }, null, 8, ["name"])
    ]),
    _createElementVNode("h5", null, _toDisplayString(_ctx.title), 1),
    (_ctx.dateTime)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "timer-separator" }, "|", -1)),
          _createElementVNode("p", null, _toDisplayString(_unref(getCurrentTime)(_ctx.dateTime)), 1)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})